export default "__VITE_ASSET__CcubEDtc__"